import index from '@/plugins/index'
import elementPlusLoading from '@/plugins/elementPlusLoading'
import elementPlusMessage from '@/plugins/elementPlusMessage'
import elementPlusNotify from '@/plugins/elementPlusNotify'
export default (app: any) => {
  app.use(index)
  // app.use(elementPlusLoading)
  // app.use(elementPlusMessage)
  // app.use(elementPlusNotify)
}
